import moment from 'moment';

const ScheduleMondayField = ({HorarioLunes}:any) => {
    const dateSplit = HorarioLunes ? HorarioLunes.split(' - ') : null;
    return (
        <div>
            <label>{ dateSplit ? moment(dateSplit[0]).format('hh:mm A') +" - "+moment(dateSplit[1]).format('hh:mm A') : ''}</label>
        </div>
    )
}

export default ScheduleMondayField
